module.exports = __webpack_public_path__ + "img/methods (3).7fd3552b.png";